import { render } from "./Order2SList.vue?vue&type=template&id=255b8e7c&scoped=true"
import script from "./Order2SList.vue?vue&type=script&lang=js"
export * from "./Order2SList.vue?vue&type=script&lang=js"

import "./Order2SList.vue?vue&type=style&index=0&id=255b8e7c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-255b8e7c"

export default script